import { FeatureFlag } from "./featureFlagSlice"

/** Type for the resolved response of the function. */
interface FetchFlagsResponse {
  data: FeatureFlag[]
}

/**
 * Function that fetches flags set in the environment variables and returns them.
 */
export const fetchFlags = ():Promise<FetchFlagsResponse> => {

  /** Filter all env vars that start with REACT_APP_FLAG_ */
  const envFlags:string[] = Object.keys(process.env).filter(
    (envVar: string) => envVar.startsWith('REACT_APP_FLAG_')
  )

  /** Map the env flags to the correct format for the FeatureFlag type */
  const flags:FeatureFlag[]  = envFlags.map(
    flagName => ({
      name: flagName.replace('REACT_APP_FLAG_','').toLowerCase(), 
      isActive: process.env[flagName]?.toLowerCase() === 'true'
    })
  )

  return Promise.resolve({ data: flags })
}
